import type { IntlShape } from '@liveauctioneers/hammer-ui-core/intl';

import type { SaveSearchFeedback } from '@/redux/modules/search/save/saveSearch.types';

/**
 * Copy for `SaveSearchFeedback.invalidFacets`, for callers outside a component that receive `formatMessage`
 * as an argument; components get the same toast from `useSubmitSaveSearch`.
 */
export const getInvalidFacetsToast = (
    formatMessage: IntlShape['formatMessage']
): NonNullable<SaveSearchFeedback['invalidFacets']> => ({
    description: formatMessage({ id: 'toastMessages.descriptions.searchNotSavedInvalidFilters' }),
    title: formatMessage({ id: 'toastMessages.titles.searchNotSaved' }),
});
